import React from 'react';

const DateFilterBar = ({
  draftStartDate,
  draftEndDate,
  draftGooglePrice,
  draftMetaPrice,
  onStartDateChange,
  onEndDateChange,
  onGooglePriceChange,
  onMetaPriceChange,
  onApply,
  onClear,
  onQuickFilter,
  activeQuickFilter,
  onRefresh,
  loading
}) => {
  const quickFilters = [
    { key: 'today', label: 'Today' },
    { key: 'yesterday', label: 'Yesterday' },
    { key: 'last7', label: 'Last 7 Days' },
    { key: 'last30', label: 'Last 30 Days' },
    { key: 'thisMonth', label: 'This Month' },
    { key: 'lastMonth', label: 'Last Month' }
  ];

  return (
    <div className="rounded-2xl bg-white shadow-md border border-gray-100 p-4 sm:p-5">
      <div className="flex flex-col gap-4">
        <div className="flex flex-col xl:flex-row xl:items-end gap-4">
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3">
            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1">Start Date</label>
              <div className="relative">
                <i className="bi bi-calendar-event absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-xs"></i>
                <input
                  type="date"
                  value={draftStartDate}
                  onChange={(e) => onStartDateChange(e.target.value)}
                  className="w-full rounded-lg border border-gray-200 pl-8 pr-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#009ef7]/30"
                />
              </div>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1">End Date</label>
              <div className="relative">
                <i className="bi bi-calendar-check absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-xs"></i>
                <input
                  type="date"
                  value={draftEndDate}
                  onChange={(e) => onEndDateChange(e.target.value)}
                  className="w-full rounded-lg border border-gray-200 pl-8 pr-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#009ef7]/30"
                />
              </div>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1">Google Price</label>
              <div className="relative">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-xs">Rs</span>
                <input
                  type="number"
                  min="0"
                  step="1"
                  value={draftGooglePrice}
                  onChange={(e) => onGooglePriceChange(e.target.value)}
                  className="w-full rounded-lg border border-gray-200 pl-8 pr-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#009ef7]/30"
                />
              </div>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1">Meta Price</label>
              <div className="relative">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-xs">Rs</span>
                <input
                  type="number"
                  min="0"
                  step="1"
                  value={draftMetaPrice}
                  onChange={(e) => onMetaPriceChange(e.target.value)}
                  className="w-full rounded-lg border border-gray-200 pl-8 pr-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#009ef7]/30"
                />
              </div>
            </div>
            <div className="flex gap-2 sm:items-end">
              <button
                type="button"
                onClick={onApply}
                disabled={loading}
                className="inline-flex h-10 items-center rounded-lg bg-[#009ef7] text-white px-4 text-xs font-medium hover:bg-[#008de0] disabled:opacity-60 disabled:cursor-not-allowed"
              >
                <i className="bi bi-check2-circle mr-1"></i>
                Apply
              </button>
              <button
                type="button"
                onClick={onClear}
                disabled={loading}
                className="h-10 rounded-lg border border-gray-200 text-gray-700 px-4 text-sm font-medium hover:bg-gray-50 disabled:opacity-60 disabled:cursor-not-allowed"
              >
                Clear
              </button>
            </div>
          </div>

          <button
            type="button"
            onClick={onRefresh}
            disabled={loading}
            className="inline-flex h-10 items-center rounded-lg border border-[#009ef7] px-4 text-sm font-medium text-[#009ef7] hover:bg-[#009ef7]/5 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            <i className="bi bi-arrow-clockwise mr-1"></i>
            Refresh
          </button>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          {quickFilters.map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={() => onQuickFilter(item.key)}
              className={`rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${
                activeQuickFilter === item.key
                  ? 'bg-[#009ef7] text-white'
                  : 'border border-gray-200 text-gray-700 hover:bg-gray-50'
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DateFilterBar;



